import {
	mapActions
} from "vuex";
import moment from "moment";
import _ from "lodash";
import getMvcUrl from "../../utils/mvcUrlUtil.js";
import laiMap from '../../components/laiMap.vue';
import selectAddr from "@/components/selectAddr";
import getCheckPhone from '@/common/js/checkPhone.js';

const addForm = {
	"id": null,
	"uniqueCode": null,
	"dataOwner": null,
	"expectedPrice": null,
	"cargoType": "",
	"cargoVolume": '',
	"cargoWeight": '',
	"comment": "",
	addedComments: [],
	"needReceipt": 1,
	"receiptAddress": "",
	"receiptName": "",
	"receiptPhone": "",
	"receiptType": 1,
	"vehicleLength": null,
	"vehicleType": null,
	start: {
		"addrDetail": "",
		"cityCode": "",
		"cityName": "",
		"coordinate": "",
		"jobType": 1,
		"orderPlacerName": "",
		"orderPlacerPhone": "",
		"sortNum": 1
	},
	stops: [],
	end: {
		"addrDetail": "",
		"cityCode": "",
		"cityName": "",
		"coordinate": "",
		"jobType": 2,
		"orderPlacerName": "",
		"orderPlacerPhone": "",
		"sortNum": 2
	}
}
export default {
	components: {
		laiMap,
		selectAddr
	},
	data() {
    // 手机号校验
    const checkStopPhone = getCheckPhone(false);

		return {
			show: {
				UsualLine_Add: false,
				UsualLine_Again: false,
				UsualLine_Del: false,
				UsualLine_Query: false
			},
			addressList: [],
			addAddressVisible: false,
			formDisabled: false,
			editDisabled: false,
			currentRow: null,
			optType: null,
			optTitle: null,
			loading: false,
			saveLoading: false,
			mapVisible: false,
			currentPassAddrIndex: '0',
			currentPoint: null,
			receiptTypes: [{
				value: 1,
				label: '电子'
			},
			{
				value: 2,
				label: '电子+纸质'
			}
			],
			form: {},
			prev: {
				"cargoInfos": [],
				"dataOwner": [],
				modes: '',
				"ownerName": "",
				"placerNames": [],
				comments: ["三不超", "需雨布", "带尾板", "无禁区", "全程高速"]
			},
			uploadUsualLineLoading: false,
			importDialogTableVisible: false,
			addDialogTableVisible: false,
			fileName: '',
			qeuryForm: {
				srcAddrSelects: [],
				destAddrSelects: [],
				vehicleType: null,
				vehicleLength: null,
				orderPlacer: null,
				pageNum: 1,
				pageSize: 10,
			},
			addrOptions: [],
			addVehicleLengthList: [],
			vehicleLengthList: [],
			vehicleTypeList: [],
			vehicleLength: [],
			vehicleLengthMap: {},
			total: 0,
			table: [],
      checkStopPhone,
			rules: {
				expectedPrice: [{
					required: true,
					message: '请输入期望运费',
					trigger: 'blur'
				},
				{
					pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					message: '请输入正确的期望运费',
					trigger: 'blur'
				}
				],
				cargoWeight: [{
					required: true,
					message: '请输入货物重量',
					trigger: 'blur'
				},
				{
					pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					message: '请输入正确的货物重量',
					trigger: 'blur'
				}
				],
				cargoVolume: [{
					required: true,
					message: '请输入货物体积',
					trigger: 'blur'
				},
				{
					pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
					message: '请输入正确的货物体积',
					trigger: 'blur'
				}
				]
			},
			start: {
				"addrDetail": "",
				"cityCode": "",
				"cityName": "",
				"coordinate": "",
				"jobType": 1,
				"orderPlacerName": "",
				"orderPlacerPhone": "",
				"planArriveTm": '',
				"planSendtm": '',
				"sortNum": 1
			},
			end: {
				"addrDetail": "",
				"cityCode": "",
				"cityName": "",
				"coordinate": "",
				"jobType": 2,
				"lineDistance": 0,
				"orderPlacerName": "",
				"orderPlacerPhone": "",
				"planArriveTm": '',
				"planSendtm": '',
				"sortNum": 2
			},
		}
	},
	methods: {
		...mapActions([
			'queryCarTypeListApi',
			'uploadUsualLineApi',
			'querylistAllCitysApi',
			'getUsualLineListApi',
			'delUsualLineApi',
			'saveUsualLineApi',
			'getUsualLineByIdApi',


			'addAddressApi',
			'queryAddressApi',
			'queryAddrByCoordinateApi',
			'queryAddrByKeywordApi',
			'initPlaceApi',
			'calcDisAndTmApi',
			'calcPriceApi',
			'placeOrderApi',
			'getDriverInfoApi',
			'getCarrierInfoApi',
		]),
		queryAddressList() {
			this.queryAddressApiIns = this.queryAddressApi({
				pageSize: 10000,
				pageNum: 1
			}).then(res => {
				this.addressList = res.rows;
			}).catch(e => { })
		},
		onAddAddress() {
			this.addAddressVisible = true
		},
		onSelectAddr(data, form) {
			form.addrDetail = data.address;
			form.cityCode = data.cityCode;
			form.cityName = data.cityName;
			form.coordinate = data.coordinate;
			form.orderPlacerName = data.contacts;
			form.orderPlacerPhone = data.phone;
		},
		callBackFun(result) {
			this.mapVisible = false;
			if ('only-close' != result.data) {
				//业务代码处理
				if (result.invokeId == 'start') {
					this.form.start.addrDetail = result.data.addrDetail;
					this.form.start.cityCode = result.data.cityCode;
					this.form.start.cityName = result.data.cityName;
					this.form.start.coordinate = result.data.coordinate;
				} else if (result.invokeId == 'end') {
					this.form.end.addrDetail = result.data.addrDetail;
					this.form.end.cityCode = result.data.cityCode;
					this.form.end.cityName = result.data.cityName;
					this.form.end.coordinate = result.data.coordinate;
				} else {
					let index = result.invokeId * 1;
					this.form.stops[index].addrDetail = result.data.addrDetail;
					this.form.stops[index].cityCode = result.data.cityCode;
					this.form.stops[index].cityName = result.data.cityName;
					this.form.stops[index].coordinate = result.data.coordinate;
				}
			}
		},
		querylistAllCitys() {
			if (this.addrOptions.length > 0) {
				return;
			}
			let addrOptionsTmp = [];
			this.addrOptions = [];
			this.querylistAllCitysApi({}).then(res => {
				if (!res) {
					return;
				}
				let result = res;
				addrOptionsTmp.push({
					value: '全国',
					label: '全国'
				});
				for (let i = 0; i < result.length; i++) {
					let obj = {};
					obj.value = result[i].code;
					obj.label = result[i].name;
					if (result[i].childCity) {
						obj.children = [];
						for (let j = 0; j < result[i].childCity.length; j++) {
							let obj2 = {};
							obj2.value = result[i].childCity[j].name;
							obj2.label = result[i].childCity[j].name;
							obj.children.push(obj2);
						}
					}
					addrOptionsTmp.push(obj);
				}
				this.addrOptions = addrOptionsTmp;
			})
		},
		queryCarTypeList() {
			this.vehicleTypeList = [];
			this.vehicleLengthMap = {};
			this.queryCarTypeListApi({}).then(res => {
				let vehicleTypeMapLens = res.typeMapLens;
				//初始化车型车长条件下拉框
				if (vehicleTypeMapLens) {
					for (let i = 0; i < vehicleTypeMapLens.length; i++) {
						this.vehicleTypeList.push({
							'value': vehicleTypeMapLens[i].plVehicleCode,
							'label': vehicleTypeMapLens[i].plVehicleType
						});
						this.vehicleLengthMap[vehicleTypeMapLens[i].plVehicleCode] = vehicleTypeMapLens[i].lens;
					}
				}
			})
		},
		uploadUsualLine() {
			if (!document.getElementById('cmFile').files[0]) {
				this.$message({
					type: "error",
					message: '请选择文件！'
				});
				return;
			}
			this.uploadUsualLineLoading = true;
			let formData = new window.FormData();
			if (document.getElementById('cmFile').files[0]) {
				formData.append('cmFile', document.getElementById('cmFile').files[0]);
			}
			this.uploadUsualLineApi(formData).then(res => {
				this.uploadUsualLineLoading = false;
				if (res && res.indexOf('{}') >= 0) {
					//失败，返回错误文件
					this.$notify({
						title: '提示',
						message: res.split('{}')[0],
						type: 'warning',
						duration: 15000
					});
					this.clearUploadFile();
					this.importDialogTableVisible = false;
					this.onSearch();
					let preUrl = getMvcUrl() + '/saas/downLoad/downLoadFile?name=' + res.split('{}')[1];
					window.open(preUrl);
				} else if ('ok' == res) {
					this.$message({
						type: "success",
						message: '导入成功!'
					});
					this.clearUploadFile();
					this.importDialogTableVisible = false;
					this.onSearch();
				} else {
					//失败，返回提示
					this.$message({
						type: "error",
						message: res
					});
				}
			}).catch(e => {
				if (e && e.succ === 'fail' && e.msg) {
					this.$message({
						type: "error",
						message: e.msg
					});
				}
				this.uploadUsualLineLoading = false;

			}).finally(() => { });
		},
		jumpOrder(row) {
			let params = {};
			params.lineId = row.id;
			this.getUsualLineByIdApi(params).then(res => {
				window.sessionStorage.setItem('usualLineToShipmentsParams', JSON.stringify(this.getById(res)));
				this.$router.push("/manage/Shipments");
			}).catch(e => {
				if (e && e.succ === 'fail' && e.msg) {
					this.$message({
						type: "error",
						message: e.msg
					});
				}
			}).finally(() => { });
		},
		getUsualLineList() {
			this.loading = true;
			this.table = [];
			let params = {};
			if (this.qeuryForm.srcAddrSelects.length == 2) {
				params.srcCityName = this.qeuryForm.srcAddrSelects[1];
			}
			if (this.qeuryForm.destAddrSelects.length == 2) {
				params.destCityName = this.qeuryForm.destAddrSelects[1];
			}
			params.vehicleType = this.qeuryForm.vehicleType;
			params.vehicleLength = this.qeuryForm.vehicleLength;
			params.orderPlacer = this.qeuryForm.orderPlacer;
			params.pageNum = this.qeuryForm.pageNum;
			params.pageSize = this.qeuryForm.pageSize;
			this.getUsualLineListApi(params).then(res => {
				this.table = res.rows;
				this.total = res.totalCount;
			}).catch(e => {
				if (e && e.succ === 'fail' && e.msg) {
					this.$message({
						type: "error",
						message: e.msg
					});
				}
			}).finally(() => {
				this.loading = false;
			});
		},
		importDialogClosed(fun) {
			this.clearUploadFile();
			if (fun) {
				fun();
			}
		},
		//type=1新增,2=修改,3=查看
		opt(type, row) {
			this.optType = type;
			this.currentRow = row;
			this.addDialogTableVisible = true;
		},
		buildPassInfo2(obj) {
			let targetObj = {};
			targetObj.addrDetail = obj.addrDetail;
			targetObj.cityCode = obj.cityCode;
			targetObj.cityName = obj.cityName;
			targetObj.coordinate = obj.coordinate;
			targetObj.jobType = obj.jobType;
			targetObj.orderPlacerName = obj.contactName;
			targetObj.orderPlacerPhone = obj.contactPhone;
			targetObj.sortNum = obj.sortNum;
			return targetObj;
		},
		addDialogOpened() {
			if (this.optType != 1) {
				this.saveLoading = true;
				let params = {};
				params.lineId = this.currentRow.id;
				this.getUsualLineByIdApi(params).then(res => {
					this.saveLoading = false;
					this.form = this.getById(res);
				}).catch(e => {
					if (e && e.succ === 'fail' && e.msg) {
						this.$message({
							type: "error",
							message: e.msg
						});
					}
				}).finally(() => {
					this.saveLoading = false;
				});
			}
		},
		getById(res) {
			let formTmp = {};
			formTmp.id = res.id;
			formTmp.cargoType = res.cargoType;
			formTmp.cargoVolume = res.cargoVolume;
			formTmp.uniqueCode = res.uniqueCode;
			formTmp.cargoWeight = res.cargoWeight;
			formTmp.comment = res.comment;
			//不需要回单
			if (res.needReceipt == 2) {
				formTmp.needReceipt = 1;
			} else {
				formTmp.receiptType = res.receiptType;
				// 电子回单
				if (formTmp.receiptType == 1) {
					formTmp.needReceipt = 2;
				}
				// 电子+纸质回单
				if (formTmp.receiptType == 2) {
					formTmp.needReceipt = 3;
					formTmp.receiptAddress = res.receiptAddress;
					formTmp.receiptName = res.receiptName;
					formTmp.receiptPhone = res.receiptPhone;
				}
			}
			formTmp.vehicleType = res.vehicleType;
			formTmp.vehicleLength = res.vehicleLength + '';
			formTmp.expectedPrice = res.expectedPrice;
			formTmp.dataOwner = res.dataOwner;
			formTmp.lineDistance = res.lineDistance;
			formTmp.stops = [];
			formTmp.addedComments = [];
			if (res.passZoneResponseList.length >= 2) {
				formTmp.start = this.buildPassInfo2(res.passZoneResponseList[0]);
				formTmp.end = this.buildPassInfo2(res.passZoneResponseList[res.passZoneResponseList.length - 1]);
				if (res.passZoneResponseList.length > 2) {
					for (let i = 1; i < res.passZoneResponseList.length - 1; i++) {
						formTmp.stops.push(this.buildPassInfo2(res.passZoneResponseList[i]));
					}
				}
			}
			return formTmp;
		},

		buildPassInfo(obj) {
			let targetObj = {};
			targetObj.addrDetail = obj.addrDetail;
			targetObj.coordinate = obj.coordinate;
			targetObj.cityCode = obj.cityCode;
			targetObj.cityName = obj.cityName;
			targetObj.jobType = obj.jobType;
			targetObj.contactName = obj.orderPlacerName;
			targetObj.contactPhone = obj.orderPlacerPhone;
			return targetObj;
		},
		saveUsualLine() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					this.saveLoading = true;
					let passZoneParamList = [];
					let param = JSON.parse(JSON.stringify(this.form));
					//组装始发目的信息
					param.srcCity = param.start.cityCode;
					param.srcCityName = param.start.cityName;
					param.srcCoordinate = param.start.coordinate;
					param.srcAddr = param.start.addrDetail;

					param.destCity = param.end.cityCode;
					param.destCityName = param.end.cityName;
					param.destCoordinate = param.end.coordinate;
					param.destAddr = param.end.addrDetail;

					//组装经停信息
					passZoneParamList.push(this.buildPassInfo(param.start));
					if (param.stops.length > 0) {
						for (let i = 0; i < param.stops.length; i++) {
							passZoneParamList.push(this.buildPassInfo(param.stops[i]));
						}
					}
					passZoneParamList.push(this.buildPassInfo(param.end));
					param.passZoneParamList = passZoneParamList;
					if (param.needReceipt == 3) {
						param.receiptAddress = this.form.receiptAddress;
						param.receiptName = this.form.receiptName;
						param.receiptPhone = this.form.receiptPhone;
					}
					if (param.needReceipt == 1) {
						param.receiptType = null;
						param.needReceipt = 2;
					} else if (param.needReceipt == 2) {
						param.receiptType = 1;
						param.needReceipt = 1;
					} else if (param.needReceipt == 3) {
						param.receiptType = 2;
						param.needReceipt = 1;
					}
					delete param.start;
					delete param.end;
					delete param.stops;
					delete param.addedComments;

					this.saveUsualLineApi(param).then(res => {
						this.saveLoading = false;
						if (res == true) {
							this.$message({
								type: "success",
								message: '保存成功！'
							});
							this.addDialogTableVisible = false;
							this.onSearch();
						} else {
							this.$message({
								type: "error",
								message: '保存失败！'
							});
						}
					}).catch(e => {
						if (e && e.succ === 'fail' && e.msg) {
							this.$message({
								type: "error",
								message: e.msg
							});
						}
						this.saveLoading = false;
					})

				}
			})
		},
		del(row) {
			this.$confirm('确定要删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {};
				params.id = row.id;
				this.delUsualLineApi(params).then(res => {
					this.onSearch();
					if (res == true) {
						this.$message({
							type: "success",
							message: '删除成功！'
						});
					} else {
						this.$message({
							type: "error",
							message: '删除失败！'
						});
					}
				}).catch(e => {
					if (e && e.succ === 'fail' && e.msg) {
						this.$message({
							type: "error",
							message: e.msg
						});
					}
				})
			}).catch(() => { });

		},
		onReset() {
			Object.assign(this.qeuryForm, this.$options.data().qeuryForm)
		},
		onSearch() {
			this.qeuryForm.pageNum = 1;
			this.getUsualLineList();
		},
		onSizeChange() { },
		onCurrentChange(val) {
			this.qeuryForm.pageNum = val;
			this.getUsualLineList();
		},
		mapVehicle(code) {
			for (let i = 0; i < this.vehicleTypeList.length; i++) {
				if (this.vehicleTypeList[i].value == code) {
					return this.vehicleTypeList[i].label;
				}
			}
		},
		mapCargoInfo(code) {
			for (let i = 0; i < this.prev.cargoInfos.length; i++) {
				if (this.prev.cargoInfos[i].value == code) {
					return this.prev.cargoInfos[i].label;
				}
			}
		},
		mapPricingManner(code) {
			if (code == 2) {
				return '元/趟';
			}
			return code;
		},
		mapNeedReceipt(row) {
			if (row.needReceipt == 1) {
				if (row.receiptType == 1) {
					return '电子回单';
				}
				if (row.receiptType == 2) {
					return '电子+纸质回单';
				}
				return row.receiptType;
			}
			if (row.needReceipt == 2) {
				return '不需要';
			}
			return row.needReceipt;
		},
		formatTm(v) {
			if (v) {
				return moment(new Date(v)).format("YYYY-MM-DD HH:mm:ss");
			}
			return null;
		},
		checkFileSure(val) {
			this.fileName = document.querySelector('#cmFile').files[0].name;
		},
		checkFile() {
			document.querySelector('#cmFile').click()
		},
		downLoadTpl() {
			let preUrl = getMvcUrl() + '/saas/downLoad/downLoadTpl?tplName=usualLine.xlsx';
			window.open(preUrl);
		},
		clearUploadFile() {
			document.getElementById('cmFile').value = '';
			this.fileName = '';
		},

		onAddComment(item) {
			if (this.form.addedComments.indexOf(item) == -1) {
				this.form.addedComments.push(item)
			} else {
				this.form.addedComments.pop(item)
			}
			this.form.comment = this.form.addedComments.join(' ')
		},
		onAddStop() {
			if (this.form.stops.length == 10) {
				this.$message({
					type: 'warning',
					message: '最多添加10个经停点'
				})
				return;
			}
			let sortNum = this.form.stops.length + 2
			let stop = {
				"addrDetail": "",
				"cityCode": "",
				"cityName": "",
				"coordinate": "",
				"jobType": null,
				"orderPlacerName": "",
				"orderPlacerPhone": "",
				"sortNum": sortNum
			}
			this.form.stops.push(stop);
			this.form.end.sortNum = sortNum + 1
		},
		onDeleteStop(index) {
			let sortNum = this.form.stops.length
			this.form.stops.splice(index, 1);
			this.form.stops.forEach((item, index) => {
				item.sortNum = index + 2
			})
			this.form.end.sortNum = sortNum + 1
		},
		onOpenMap(index) {
			if (this.editDisabled) {
				return;
			}
			this.currentPassAddrIndex = index + '';
			if (index == 'start') {
				this.currentPoint = JSON.stringify(this.form.start);
			} else if (index == 'end') {
				this.currentPoint = JSON.stringify(this.form.end);
			} else {
				this.currentPoint = JSON.stringify(this.form.stops[index]);
			}
			this.mapVisible = true;
		},
		addDialogClosed(fun) {
			this.clearAddInfo();
			if (fun) {
				fun();
			}
		},
		addDialogClose() {
			this.clearAddInfo();
		},
		clearAddInfo() {
			this.$refs["formRef"].resetFields();
			this.form = JSON.parse(JSON.stringify(addForm));
		},
		clearReceiptInfo() {
			this.form.receiptAddress = null;
			this.form.receiptName = null;
			this.form.receiptPhone = null;
			this.form.receiptType = null;
		},
	    getFileByCode(fileCode) {
			let carImage = '';
			try {
			  carImage = require('@/assets/car' + fileCode + '.png')
			} catch(e){
			  carImage = require('@/assets/car-default.png')
			}
			return carImage
		  }
	},
	watch: {
		'form.needReceipt': function (val) {
			if (val != 3) {
				this.clearReceiptInfo();
			}
		},
		'qeuryForm.vehicleType': function (val) {
			let lengths = this.vehicleLengthMap[val];
			let lens = [];
			this.qeuryForm.vehicleLength = null;
			if (lengths) {
				for (let i = 0; i < lengths.length; i++) {
					lens.push({
						'value': lengths[i],
						'label': lengths[i] + '米'
					});
				}
			}
			this.vehicleLengthList = lens;
		},
		'form.vehicleType': function (val) {
			let lengths = this.vehicleLengthMap[val];
			let lens = [];
			if (lengths) {
				let has = 0;
				for (let i = 0; i < lengths.length; i++) {
					lens.push({
						'value': lengths[i],
						'label': lengths[i]
					});
					if (lengths[i] == this.form.vehicleLength) {
						has = 1;
					}
				}
				if (has == 0) {
					this.form.vehicleLength = null;
				}
			}
			this.addVehicleLengthList = lens;
		},
		optType: function (val) {
			if (val == 1) {
				this.editDisabled = false;
				this.formDisabled = false;
				this.optTitle = '新增线路';
			}
			if (val == 2) {
				this.editDisabled = false;
				this.formDisabled = false;
				this.optTitle = '编辑线路';
			}
			if (val == 3) {
				this.editDisabled = true;
				this.formDisabled = true;
				this.optTitle = '查看线路';
			}

		}
	},
	computed: {},
	mounted() {
		this.querylistAllCitys();
		this.getUsualLineList();
		this.queryAddressList();
	},
	created() {
		let menuInterval = setInterval(() => {
			let map = JSON.parse(sessionStorage.getItem('menuMap'))
			if (map) {
				clearInterval(menuInterval)
				let submenuList = map['UsualLine'].split('-');
				submenuList.forEach((item, i) => {
					this.show[item] = true;
				});
			}
		}, 30);
		this.form = JSON.parse(JSON.stringify(addForm));
		this.initPlaceApi({}).then(res => {
			this.prev.cargoInfos = res.cargoInfos
			this.prev.dataOwner = res.dataOwner
			this.prev.modes = res.modes
			this.prev.ownerName = res.ownerName
			this.prev.placerNames = res.placerNames
		}).catch(e => {
			if (e && e.succ === 'fail' && e.msg) {
				this.$message({
					type: "error",
					message: e.msg
				});
			}
		});
		this.queryCarTypeList();
	}
}
